import React from "react";

export type FadeScrollerProps = {
  /**
   * Classes for the outer container. Do not apply scroll-related classes or
   * padding to this to get the best behavior.
   */
  className?: string;
  /**
   * Classes for the inner container. Add scroll classes ("overflow-auto") and
   * padding to this one for the best behavior.
   */
  contentClassName?: string;
  /**
   * Size of the fade at the top and bottom edges. Should not be greater than
   * the top / bottom padding of the content. Defaults to 1.5rem.
   */
  fadeSize?: string;
  children: React.ReactNode;
};

export const FadeScroller: React.FC<FadeScrollerProps> = ({
  className,
  contentClassName,
  fadeSize = "1.5rem",
  children,
}) => {
  return (
    <div className={className}>
      <div
        className={contentClassName}
        style={{
          maskImage: `linear-gradient(to bottom, transparent, black ${fadeSize}, black calc(100% - ${fadeSize}), transparent)`,
        }}
      >
        {children}
      </div>
    </div>
  );
};
